(function($) {

  $('[data-toggle="modal"]').on('click', function(e) {
    e.preventDefault();
    let $dataTarget = $($(this).data('target')) || $($(this).attr('href'));

    $dataTarget.modal('show');
  });

  $('.dataToggleModal').on('click', function(e) {
    e.preventDefault();
    $(this).attr('data-toggle', 'modal');
    let $dataTarget = $($(this).data('target')) || $($(this).attr('href'));

    $dataTarget.modal('show');
  });

})(jQuery)